import { Activity, MessageCircle, PauseCircle, ShieldCheck } from 'lucide-react';

const POINTS = [
  {
    icon: Activity,
    title: 'Real-time visibility',
    body: 'Watch your campaign work as it runs — not days later.',
  },
  {
    icon: PauseCircle,
    title: 'Pause anytime',
    body: 'Change direction or stop spend without friction.',
  },
  {
    icon: ShieldCheck,
    title: 'Brand-safe by default',
    body: 'Your brand only shows up where it belongs.',
  },
  {
    icon: MessageCircle,
    title: 'A team you can reach',
    body: 'Real humans behind every campaign, not just dashboards.',
  },
];

export function TrustStrip() {
  return (
    <section className="border-y border-border-soft bg-surface-sunken/40">
      <div className="mx-auto max-w-container-lg px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-x-9 gap-y-9 sm:grid-cols-2 lg:grid-cols-4">
          {POINTS.map(({ icon: Icon, title, body }) => (
            <div key={title} className="flex gap-3.5">
              <div className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-surface text-primary shadow-xs">
                <Icon className="h-5 w-5" aria-hidden />
              </div>
              <div className="min-w-0">
                <div className="text-base font-semibold text-ink">{title}</div>
                <div className="mt-1 text-base leading-body text-ink-secondary">
                  {body}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
